export default __webpack_public_path__ + "static/media/JUSOS.eaf93b36.mp4";